import Paginador from "./Paginador";
export default Paginador;